import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorService } from '../../../core/services/error.service';

@Component({
    selector: 'app-statements-reports',
    templateUrl: './statements-reports.component.html',
    standalone: false
})
export class StatementsReportsComponent implements OnInit {
  selectedTab: string = 'statements';
  productBadges = ['ecf', 'pstx'];

  constructor(
    private errorService: ErrorService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.selectedTab = params.selectedTab ?? 'statements';
    });
  }
}
